/**
 * SubHeroAnim — 서브 히어로 영역 GSAP 텍스트/요소 애니메이션
 * AOS 대신 timeline + 텍스트 스플릿(문자 단위) 적용
 */
export class SubHeroAnim {
    constructor() {
        this.section = null;
        this.timeline = null;
    }

    init() {
        this.section = document.querySelector(".no-sub-hero");
        if (!this.section || typeof gsap === "undefined") return;

        if (typeof ScrollTrigger !== "undefined" && gsap.registerPlugin) gsap.registerPlugin(ScrollTrigger);

        const highlight = this.section.querySelector(".no-sub-hero__highlight");
        const title = this.section.querySelector(".no-sub-hero__title");
        const nav = this.section.querySelector(".no-sub-hero__nav");
        const navLinks = nav ? nav.querySelectorAll(".no-sub-nav__link") : [];

        // 애니메이션 대상: highlight, title(글자 또는 통째로), nav 링크 — 모두 한 번에
        const targets = [];

        if (highlight) {
            gsap.set(highlight, { opacity: 0, y: 20 });
            targets.push(highlight);
        }

        const titleChars = [];
        if (title && title.textContent.trim()) {
            this._splitTitleIntoChars(title, titleChars);
            if (titleChars.length) {
                gsap.set(titleChars, { opacity: 0, y: 20 });
                targets.push(...titleChars);
            }
        } else if (title) {
            gsap.set(title, { opacity: 0, y: 20 });
            targets.push(title);
        }

        navLinks.forEach((link) => {
            gsap.set(link, { opacity: 0, y: 20 });
            targets.push(link);
        });

        if (targets.length === 0) return;

        // 한 번에 아래에서 위로 (stagger 없음, li마다 to to to 없음)
        gsap.to(targets, {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            overwrite: true,
        });
    }

    _splitTitleIntoChars(titleEl, outChars) {
        if (titleEl.classList.contains("is-split")) return;
        const text = titleEl.textContent || "";
        if (!text.trim()) return;

        titleEl.classList.add("is-split");
        titleEl.textContent = "";
        text.split("").forEach((c) => {
            const span = document.createElement("span");
            span.className = "no-sub-hero__title-char";
            span.textContent = c;
            titleEl.appendChild(span);
            outChars.push(span);
        });
    }
}
